/**
 * 榜单列表
 * data-threshold优先级高于实例化时候传入的统一配置参数。
 */
define(function(require, exports, module) {
    var RankList = require('../base/ranklist');
    var ItemTpl = require('./item.tmpl');
    var tipTpl = require('./tip.tmpl');

    var GalaPop = require('../../lib/normalPop');

    const HostList = RankList.extend({
        defaults: {
            wrap: '#J-SendHostList',
            itemTpl: ItemTpl,
            getListData: function(data) {
                return data.list|| [];
            },
        },

        initialize() {
            let self = this;

            self.Parent.apply(self, arguments);

            self.set('url', UpAct.CONFIG.board());

            self.acidInfo = self.get("acidInfo");

            self.actInfo = UpAct.actData[self.acid];

            self.set('initParams',{ area: self.acidInfo.areaCode });

            self.getAreaIndex();

            self.selectedInfo = UpAct.CONFIG.acidConfig.acid[self.selectedAreaIndex];

            self.renderTip(self.selectedInfo.uniqueId,self.selectedInfo.text);

            this.bindSendEvent();

        },

        renderTip(code,name){

            let self = this;

            let wrap = $(self.get('wrap').find(".list-wrap .content"))
            wrap.prepend(tipTpl({
                areaName: name
            }));
        },

        getAreaIndex(){

            let self = this;

            console.log("vewfw");

            $.each(UpAct.CONFIG.acidConfig.acid, (index, items)=>{
                if (items.uniqueId.indexOf(self.acidInfo["uniqueId"].split("-")[0]) > -1) {
                    self.selectedAreaIndex = index;
                }
            });
        },

        bindSendEvent(){
            let self = this;
            let wrap = $(self.get('wrap').find(".list-wrap .content"));

            console.log("vaewnor");
            wrap.delegate(".cf-tip-btn","click",()=>{
                let pop = new GalaPop({
                    title: UpAct.lang.areaTemplate(self.selectedInfo.uniqueId,'财富奖励标题'),
                    context: UpAct.lang.areaTemplate(self.selectedInfo.uniqueId,'财富榜奖励')+
                    (self.selectedInfo.uniqueId === 'zhtw'?`<div class="rule-gift2"><img src="${require('../../../images/rule-gift2.jpg')}"></div>`:''),
                
                    //btnContext: ,
                    onCreate: (el,popup,gala)=>{
                        el.addClass('widget-poplayer-rule');
                    },
                    onClose: (el)=>{
                    }
                });

                pop.create();
            });
        },

        formatResult:function(res){
            if(res.errcode === 0){
                return {
                    code: "SC_SUCCESS",
                    data: res.data
                }
            }else{
                return {
                    code: "",
                    data: {}
                }
            }
            return res;
        },
    });

    UpAct.SendHostList = HostList;
});



// WEBPACK FOOTER //
// ./js/component/send-hostList/index.js